<router-outlet></router-outlet>

<ngx-spinner bdColor="rgba(0, 0, 0, 0.6)" size="medium" color="#181715" type="ball-spin" [fullScreen]="true"></ngx-spinner>